import { render, staticRenderFns } from "./BedbuilderSubOptionsCard.vue?vue&type=template&id=14ff254f&"
import script from "./BedbuilderSubOptionsCard.vue?vue&type=script&lang=js&"
export * from "./BedbuilderSubOptionsCard.vue?vue&type=script&lang=js&"
import style0 from "./BedbuilderSubOptionsCard.vue?vue&type=style&index=0&id=14ff254f&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BedbuilderUnavailableModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/bedbuilder/BedbuilderUnavailableModal.vue').default,AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default})
